import React from "react";
import Portal from "./Portal";
import styled from "styled-components"
import { Panel, LazyBoi, Grid } from "@components"
import { Asset } from '@archetypes'
import { fromWei, formatTimestamp, parsePoolWeight, calculateAPY } from "@util/helpers"

const Modal = styled(
    ({ className, children, close, render }) => {
        return (
            <Portal>
                <div className={className}>
                    <div className="-modal-wrapper">
                        <div className="-modal">
                            <button onClick={close} className="close-icon"> X</button>
                            {render(children) || children}
                        </div>
                    </div>
                    <div className="-bg" />
                </div>
            </Portal>
        );
    })`
    
    >.-bg {
        position: fixed;
        height: 100%;
        width: 100%;
        top: 0px;
        background-color: black;
        opacity: 0.7;
        z-index: 4;
    }

    >.-modal-wrapper{

        >.-modal {
            position: fixed;
            top: 20%;
            left: 50%;
            margin-left: -200px;
            min-width: 400px;
            width: 400px;
            max-height: 600px;
            z-index: 10;
            box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.3);
            background: var(--panel--background--color, grey);
            border-radius: 8px;
             
            .close-icon {
                position: absolute;
                right: 10px;
                top: 10px;
                background-color: #4CAF50; 
                height: 24px;
                width: 24px;
                border-width:1px;
                border-style: solid;
                border-color: var(--color-label, lightblue);
                background: var(--panel--background--color, grey);
                cursor: pointer;
                text-align: center;
                font-weight: 700;
                text-decoration: none;
                display: inline-block;
                font-size: 12px;
                margin: 2px 2px;
                border-radius: 50%;
            }         
        }
    }
    `
Modal.NotConnected = styled(
    ({ className, close }) => {
        return (
            <Modal
                close={close}
                render={() => (
                    <div className={className}>
                        <h4>
                            Please connect your wallet first
                        </h4>
                    </div>
                )}
            />
        )

    })`
    padding: 40px;
    padding-bottom: 20px;
    text-align: center;
    h4 {
        font-size: 18px;
        line-height: 32px;
        margin: 0px;
        margin-bottom: 1rem;
    }
    `


Modal.TokenSelection = styled(
    ({ className, close, tokens, onSelect }) => {

        return (
            <Modal
                close={close}
                render={() => (
                    <div className={className}>
                        <h4>Select a token</h4>
                        <Panel.Divider light noMargin />
                        {tokens.length === 0 ? (<h3>Loading...</h3>) :
                            <div className="-token-list">
                                {tokens.map((token, index) => (
                                    <div className="-token-item" key={index}>
                                        <div onClick={() => onSelect(token.symbol)}>
                                            <Asset.Icon token={token.symbol} />
                                        </div>
                                        <div>
                                            <LazyBoi value={token.balance} fromWei dp={2} />
                                        </div>
                                    </div>)
                                )}
                            </div>
                        }
                    </div>
                )}
            />
        )
    })`
    padding: 20px; 
    h3, h4 {
        font-size: 18px;
        line-height: 32px;
        margin: 0px;
        margin-bottom: 1rem;
    }
    h3 {
        padding-top: 20px;
        padding-bottom: 20px;
    }
    >.-token-list {
        overflow-y: scroll;
        height: 400px;



        ::-webkit-scrollbar {
            width: 10px;
        }
        ::-webkit-scrollbar-track {
            background: #f1f1f1;
        }
        ::-webkit-scrollbar-thumb {
            background: #888;
        }
        ::-webkit-scrollbar-thumb:hover {
            background: #555;
        }
        .-token-item {
            height: 70px;
            font-size: 16px;
            font-weight: 600;
            display: flex;
            flex-direction: row;
            .-svg{
                width: 36px;
                height: 36px;
                fill: rgba(255,255,255,0.3);
        
            }
            .-img{
                width: calc(36px);
                height: calc(36px);
                background: rgba(0,0,0,1);
                border-radius: 50%;
                border: 1px solid rgba(216, 216, 216, 0.6);
            }
            div {
                flex: 2;
                margin-top: auto;
                margin-bottom: auto;
                :last-child {
                    flex: 1;
                    font-weight: 400;
                    color: var(--color-label);
                    text-align: right;
                    padding-right: 20px;
                }
                :first-child {
                    cursor: pointer;
                }
            }
            
        }
    }
    
    

    `

Modal.AssetInfo = styled(
    ({ className, close, emp }) => {

        return (
            <Modal
                close={close}
                render={() => (
                    <div className={className}>
                        <div className="-header">
                            <Asset.Icon.Dual
                                token={[emp?.token1?.symbol]}
                            />
                            <div className="-info">
                                <h4>
                                    {emp?.token1?.symbol}
                                </h4>
                                <p>
                                    {emp?.token1?.name}
                                </p>
                            </div>
                        </div>
                        <Panel.Divider light noMargin />
                        <div className="-body">
                            <h4>Asset details</h4>
                            <Grid cols={2} className="-grid">
                                <div>
                                    <h4>Min. PERL required to mint</h4>
                                    <p>{Number(fromWei(emp?.minCollateral)).toLocaleString()} PERL</p>
                                </div>
                                <div>
                                    <h4>Token Expiry</h4>
                                    <p>{formatTimestamp(emp?.expirationTimestamp)}</p>
                                </div>
                                <div>
                                    <h4>Liquidation Ratio</h4>
                                    <p>{(Number(fromWei(emp?.collateralRequirement))).toLocaleString()}</p>
                                </div>
                                <div>
                                    <h4>Global Collateral Ratio (USD)</h4>
                                    <p>{(Number((emp?.actualGCR) )).toLocaleString()}</p>
                                </div>
                                <div>
                                    <h4>Min. Sponsor Tokens</h4>
                                    <p>{(Number(fromWei(emp?.minSponsorTokens))).toLocaleString()}</p>
                                </div>
                                <div>
                                    <h4>Global Collateral Ratio (Token)</h4>
                                    <p>{(Number((emp?.globalCollateralisationRatio) / 100)).toLocaleString()}</p>
                                </div>
                            </Grid>
                        </div>
                    </div>
                )}
            />)
    })`
    padding: 20px; 
    display: flex;
    flex-direction: column;

        >.-header {
            display: flex;
            flex-direction: row;
            margin-bottom: 2rem;
            >.-info {
                display: flex;
                flex-direction: column;
                margin-left: 2rem;
                
                h4 {
                    margin: 0px;
                    font-size: 18px;
                    line-height: 22px;
                    font-weight: 600;
                    color: var(--color-white);
                }
                p {
                    margin: 0px;
                    color: var(--color-label);
                    font-size: 14px;
                    line-height: 18px;
                    font-weight: 600;
                } 
            }

        }

        >.-body {
            margin-top: 2rem;

            .-grid {
                margin-top: 0.5rem;
            }

            h4, p {
                margin: 0px;
                font-size: 14px;
                line-height: 26px;
                font-weight: 400;
            }
            h4 {
                color: var(--color-label);
            }
            p {
                color: var(--color-white);
            }
            
        }


    `

Modal.PoolInfo = styled(
    ({ className, close, pool }) => {
        return (
            <Modal
                close={close}
                render={() => (
                    <div className={className}>
                        <div className="-header">
                            <Asset.Icon.Dual
                                token={[pool?.token0?.symbol, pool?.token1?.symbol]}
                            />
                            <div className="-info">
                                <h4>
                                    {pool?.name}
                                </h4>
                                <p>
                                    {parsePoolWeight(pool)}
                                </p>
                            </div>
                        </div>
                        <Panel.Divider small light noMargin={true} />
                        <div className="-body">
                            <h4>Pool details</h4>
                            <Grid cols={2} className="-grid">
                                <div>
                                    <h4>Volume</h4>
                                    {/* FIXME : Fetch volume */}
                                    <p>{`$${Number(0).toLocaleString()}`}</p> 
                                </div>
                                <div>
                                    <h4>Depth</h4>
                                    <p>{`$${Number(fromWei(pool?.depth.toFixed(0))).toLocaleString()}`}</p>
                                </div>
                                <div>
                                    <h4>Price</h4>
                                    <p>{`$${(pool?.token1?.dollarPrice).toLocaleString()}`}</p>
                                </div>
                                {/* <div>
                                    <h4>ROI</h4>
                                    <p>xxxx</p>
                                </div> */}
                                {/* <div>
                                    <h4>APY</h4>
                                    <p>{`${calculateAPY(pool?.token1?.symbol)}%`}</p>
                                </div> */}
                            </Grid>
                        </div>
                    </div>
                )}
            />)
    })`
        padding: 20px; 
        display: flex;
        flex-direction: column;

        >.-header {
            display: flex;
            flex-direction: row;
            margin-bottom: 2rem;
            >.-info {
                display: flex;
                flex-direction: column;
                margin-left: 2rem;
                
                h4 {
                    margin: 0px;
                    font-size: 18px;
                    line-height: 22px;
                    font-weight: 600;
                    color: var(--color-white);
                }
                p {
                    margin: 0px;
                    color: var(--color-label);
                    font-size: 14px;
                    line-height: 18px;
                    font-weight: 600;
                } 
            }

        }

        >.-body {
            margin-top: 2rem;
            .-grid {
                margin-top: 0.5rem;
            }
            h4, p {
                margin: 0px;
                font-size: 14px;
                line-height: 26px;
                font-weight: 400;
            }
            h4 {
                color: var(--color-label);
            }
            p {
                color: var(--color-white);
            }
        }

        `


export default Modal;